import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { ApolloProvider } from '@apollo/client';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import apolloClient from './helpers/apollo-client.provider';
import ErrorBoundary from './assets/components/ErrorBoundary/ErrorBoundary';


const history = createBrowserHistory();

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <ApolloProvider client={apolloClient}>
          <Router history={history}>
            <Helmet>
              <title>Deskbooking - WPP Enterprise Solutions</title>
              <meta name="author" content="WPP Enterprise Solutions" />
              <meta
                name="description"
                content="Deskbooking is an app for WPP Enterprise Solutions employees to book workstations at the San Jose company building"
              />
            </Helmet>
            <App />
          </Router>
        </ApolloProvider>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// Dismiss the static boot loader as soon as the app shell is mounted.
if (typeof window !== 'undefined' && window.__hideBootLoader) {
  window.__hideBootLoader();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
